import dayjs from '../../../utils/dayjsConfig'
import { LAST_ACTIVITY_PRIORITY } from '../constants/ocConstants'

export const resolveLastActivityDate = (activityDates) => {
  if (
    !activityDates ||
    typeof activityDates !== 'object' ||
    Object.keys(activityDates).length === 0
  ) {
    return null
  }

  for (const key of LAST_ACTIVITY_PRIORITY) {
    const value = activityDates[key]

    if (value) {
      return {
        key,
        date: dayjs(value)
      }
    }
  }

  return null
}
